import { Box, Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import bluepenSvg from "images/bluepen.svg";
import React, { useState } from "react";
import Assign from "./Assign";
import CreateLoginDetails from "./CreateLoginDetails";
import EditProfile from "./EditProfile";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "35px",
    textAlign: "center",
    borderRadius: "4px",
    // width: "425px",
    // height: "360px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    wordBreak: "break-all",
    [theme.breakpoints.down("lg")]: {
      padding: "15px",
    },
  },
  headingblue: {
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "36px",
    color: "#3F51B5",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
      lineHeight: "20px",
    },
  },
  bluetext: {
    fontSize: "20px",
    lineHeight: "36px",
    color: "#3F51B5",
    textDecorationLine: "underline",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
      lineHeight: "20px",
    },
  },
  blackheading: {
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "23px",
    letterSpacing: "0.4px",
    color: "#454545",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
      lineHeight: "20px",
    },
  },
  text: {
    // fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "36px",
    color: "#454545",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
      lineHeight: "20px",
    },
  },
  space: {
    height: "1rem",
    [theme.breakpoints.down("lg")]: {
      height: "1rem",
    },
    [theme.breakpoints.down("md")]: {
      height: "3rem",
    },
  },
  space2: {
    height: "9.3rem",
    [theme.breakpoints.down("md")]: {
      height: "8rem",
    },
  },
}));

export default function Witness({
  groData: initialGroData,
  caseId,
  companyId,
  mode,
  refresh,
  allProfiles,
}) {
  const classes = useStyles();

  const groData = initialGroData;

  const [openmodal, setOpenmodal] = useState(false);

  const handleOpenModal = () => {
    setOpenmodal(true);
  };

  const handleCloseModal = () => {
    setOpenmodal(false);
    refresh();
  };

  const [openmodal2, setOpenmodal2] = useState(false);

  const handleOpenModal2 = () => {
    setOpenmodal2(true);
  };

  const handleCloseModal2 = () => {
    setOpenmodal2(false);
  };

  const [openmodal3, setOpenmodal3] = useState(false);

  const handleOpenModal3 = () => {
    setOpenmodal3(true);
  };

  const handleCloseModal3 = () => {
    setOpenmodal3(false);
  };

  return (
    <Paper className={classes.paper}>
      <Grid container justify="space-between">
        <Grid item>
          <Typography className={classes.headingblue}>WITNESS (S)</Typography>
        </Grid>
        <Grid item>
          <img
            src={bluepenSvg}
            alt="pen image"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              if (groData.length > 0) handleOpenModal3();
              else alert("There are no profiles to edit");
            }}
          />
        </Grid>
      </Grid>
      <Box height="1rem"></Box>
      <Grid container>
        <Grid item style={{ textAlign: "left" }}>
          <Typography
            className={classes.bluetext}
            style={{ cursor: "pointer" }}
            onClick={handleOpenModal}
          >
            Assign
          </Typography>
        </Grid>
      </Grid>
      {groData.length > 0 ? (
        groData.map((item) => {
          if (item.profile.profile_type == "witness")
            return (
              <>
                <Grid container>
                  <Grid item style={{ textAlign: "left" }}>
                    <Typography className={classes.blackheading}>
                      {item.user.first_name} {item.user.last_name}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item style={{ textAlign: "left" }}>
                    <Typography className={classes.text}>
                      Email: {item.user.email}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item style={{ textAlign: "left" }}>
                    <Typography className={classes.text}>
                      Phone: {item.profile.phone_number}{" "}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item style={{ textAlign: "left" }}>
                    <Typography className={classes.text}>
                      Address:{" "}
                      {item.profile.address ? item.profile.address : "--"}
                    </Typography>
                  </Grid>
                </Grid>
                <Box className={classes.space}></Box>
              </>
            );
        })
      ) : (
        <>
          <Box className={classes.space2}></Box>
        </>
      )}
      {openmodal && (
        <Assign
          openmodal={openmodal}
          handleCloseModal={handleCloseModal}
          caseId={caseId}
          profileType={mode == "RV" ? "witness_rv" : "witness"}
          groData={groData}
          allProfiles={allProfiles}
        />
      )}

      <Grid container>
        <Grid item style={{ textAlign: "left" }}>
          <Typography
            className={classes.bluetext}
            style={{ cursor: "pointer" }}
            onClick={handleOpenModal2}
          >
            + Create login details
          </Typography>
        </Grid>
      </Grid>
      {openmodal2 && (
        <CreateLoginDetails
          openmodal={openmodal2}
          handleCloseModal={handleCloseModal2}
          caseId={caseId}
          profileType={mode == "RV" ? "witness_rv" : "witness"}
          companyId={companyId}
        />
      )}
      {openmodal3 && (
        <EditProfile
          openmodal={openmodal3}
          handleCloseModal={handleCloseModal3}
          profileData={groData}
          profileType={mode == "RV" ? "witness_rv" : "witness"}
        />
      )}
    </Paper>
  );
}
